var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MovieDetail",style:({
    background:
      'linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), center ,url(http://image.tmdb.org/t/p/original' +
      _vm.movie.backdrop_path +
      ')',
  })},[_c('div',{staticClass:"container"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Ana Sayfaya Dön")]),_c('div',{staticClass:"MovieDetail-title"},[_c('h1',[_vm._v(_vm._s(_vm.movie.original_title))])]),_c('div',{staticClass:"MovieDetail-vote"},[_c('p',[_vm._v("Ortalama Oy: "+_vm._s(_vm.movie.vote_average))])]),_c('div',{staticClass:"MovieDetail-desc"},[_c('p',[_vm._v(_vm._s(_vm.movie.overview))])]),_c('div',{staticClass:"MovieDetail-desc2"},[_c('p',[_vm._v("Vote Count :"+_vm._s(_vm.movie.vote_count))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }